import React from "react"
import styled from "styled-components"
import ProgressImg from "../../images/product/progress.svg"
import CategoriesImg from "../../images/product/categories.svg"
import DataSecurityImg from "../../images/product/security.svg"
import StoreIconsImg from "../../images/product/store_icons.svg"

import { Section, Container } from "../global"

const Features = () => (
  <Section id="features">
    <StyledContainer>
      <FeaturesGrid>
        <FeatureItem>
          <FeatureImage>
            <FeatureSVGImg src={ProgressImg} alt="Progress Image" />
          </FeatureImage>
          <FeatureDescription>
            <FeatureTitle>Visualise your progress</FeatureTitle>
            <FeatureText>
              Analyse the patterns of your actions across multiple date ranges.
            </FeatureText>
          </FeatureDescription>
        </FeatureItem>
        <FeatureItem>
          <FeatureImage>
            <FeatureSVGImg src={CategoriesImg} alt="Categories Image" />
          </FeatureImage>
          <FeatureDescription>
            <FeatureTitle>Categorise your actions</FeatureTitle>
            <FeatureText>
              Use the default categories to classify your actions or easily
              create new ones.
            </FeatureText>
          </FeatureDescription>
        </FeatureItem>
        <FeatureItem>
          <FeatureImage>
            <FeatureSVGImg src={DataSecurityImg} alt="Never Loose Data Image" />
          </FeatureImage>
          <FeatureDescription>
            <FeatureTitle>You own your data</FeatureTitle>
            <FeatureText>
              Your data stays on your phone and we will never share it with a
              3rd party.
            </FeatureText>
          </FeatureDescription>
        </FeatureItem>
        <FeatureItem>
          <FeatureImage>
            <FeatureSVGImg
              src={StoreIconsImg}
              alt="Apple and Play Store Icons"
            />
          </FeatureImage>
          <FeatureDescription>
            <FeatureTitle>Access on every platform</FeatureTitle>
            <FeatureText>
              Capture your actions wherever you are on iPhone or Android.
            </FeatureText>
          </FeatureDescription>
        </FeatureItem>
      </FeaturesGrid>
    </StyledContainer>
  </Section>
)

export default Features

const StyledContainer = styled(Container)`
  padding-bottom: 20px;
`

const FeaturesGrid = styled.div`
  /* max-width: 670px; */
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0px auto;
  grid-column-gap: 40px;
  grid-row-gap: 35px;
  @media (max-width: ${props => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    padding: 0 64px;
  }
  text-align: center;
`

const FeatureDescription = styled.div`
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  color: white;
`
const FeatureItem = styled.div`
  justify-self: start;
  align-self: center;
  display: grid;
  justify-items: center;
  grid-template-columns: 1fr 1fr;
  margin: 0px;
  @media (max-width: ${props => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    justify-items: center;
    padding: 0 0px;
  }
`

const FeatureImage = styled.div`
  display: flex;
  margin: auto;
  width: 80%;
  height: 130px;
  border-radius: 6px;
  background-color: white;

  @media (max-width: ${props => props.theme.screen.md}) {
    height: 125px;
    width: 80%;
  }

  @media (max-width: ${props => props.theme.screen.sm}) {
    height: 100px;
    width: 80%;
  }
`

const FeatureSVGImg = styled.img`
  width: 80%;
  height: 80%;
  margin: auto;
`

const FeatureTitle = styled.h4`
  color: rgb(237, 239, 240);
  letter-spacing: 0px;
  line-height: 30px;
  margin-bottom: 0px;
  text-align: left;
  @media (max-width: ${props => props.theme.screen.md}) {
    line-height: 24px;
  }
  @media (max-width: ${props => props.theme.screen.sm}) {
    text-align: center;
  }
`

const FeatureText = styled.p`
  text-align: left;
  @media (max-width: ${props => props.theme.screen.sm}) {
    text-align: center;
  }
`
